module.exports = __webpack_public_path__ + "img/cattunnel09.eda59459.jpg";